import {
  Input,
  breakpoints,
  Heading,
  IBasicStyledProps,
  theme,
} from '@notino/react-styleguide';

import { styled } from '@linaria/react';

interface IDisabledText extends IBasicStyledProps {
  disabled: boolean;
}

export const Container = styled.div`
  padding: 1rem 0;

  label {
    ${theme.typography.labelRegular}
  }

  input[type='checkbox']:focus-visible ~ span {
    outline: 2px solid ${theme.color.border.selected};
    outline-offset: 2px;
    border-radius: 0.125rem;
  }
`;

export const Description = styled.div`
  padding-left: 2.25rem;
  font-size: 0.875rem;
  a {
    text-decoration: underline;
  }
  a:hover {
    text-decoration: none;
  }

  margin-top: 0.25rem;
  color: ${theme.color.text.secondary};
  line-height: 1.5rem;
  a {
    color: ${theme.color.text.primary};
  }
`;

export const Edit = styled.span`
  cursor: pointer;
  text-decoration: underline;
  background: transparent;
  border: 0;
  padding: 0;
  font: inherit;
  color: ${theme.color.text.tertiary};
  margin-left: 6px;

  &:focus-visible {
    outline: 2px solid ${theme.color.border.selected};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const DrawerInput = styled(Input)`
  width: 100%;
  text-align: start;
`;

export const H3 = styled(Heading.H3)`
  ${theme.typography.titleMedium}
  text-align: center;
  margin: 0 0 0.75rem !important;
  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.titleSmall}
    text-align: start;
    margin: 0 !important;
  }
`;

export const EngravingImage = styled.div`
  display: flex;
  flex: 1;
  flex-basis: 100%;
  align-items: center;
  justify-content: center;
  max-height: 216px;

  img {
    max-width: 100%;
    max-height: 216px;
    flex-shrink: 0;
    object-fit: scale-down;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.25rem;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const DisabledTextWrapper = styled.div<IDisabledText>`
  color: ${(props) =>
    props.disabled ? theme.color.text.disabled : theme.color.text.primary};
`;

export const InputErrorWrapper = styled.div`
  display: flex;
  min-height: 1.6rem;
`;

export const DrawerTitle = styled.div`
  ${theme.typography.labelLarge}
  visibility: hidden;
  @media (min-width: ${breakpoints.md}) {
    visibility: visible;
    margin-bottom: 2rem;
  }
`;

export const InfoBanner = styled.div`
  background: ${theme.color.background.secondary};
  padding: 0.75rem;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0.75rem 0 1rem;
  @media (min-width: ${breakpoints.md}) {
    margin: 1.5rem 0;
  }
`;

export const Footer = styled.div`
  padding: 1rem 1.25rem;
  border-top: 1px solid ${theme.color.border.divider};
`;

export const CharCounter = styled.div`
  ${theme.typography.labelSmall400}
  color: ${theme.color.text.tertiary};
  text-align: end;
  margin-bottom: 4px;
`;
